/**
 * Offering API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferingStatusModel = 'ACTIVE' | 'EXPIRED' | 'IN_DEVELOPMENT';

export const OfferingStatusModel = {
    Active: 'ACTIVE' as OfferingStatusModel,
    Expired: 'EXPIRED' as OfferingStatusModel,
    InDevelopment: 'IN_DEVELOPMENT' as OfferingStatusModel
};

